// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../node_modules/bootstrap-icons/font/bootstrap-icons.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Custom styling for Bootstrap icons */
.bi {
  font-size: 1em;
  line-height: 1;
}

/* Icon spacing when used with text */
.bi + * {
  margin-left: 0.5rem;
}

* + .bi {
  margin-left: 0.5rem;
}

/* Icon hover effects */
.bi:hover {
  transform: scale(1.1);
  transition: transform 0.2s ease;
}

/* Specific icon sizes */
.bi-pencil-square,
.bi-trash3,
.bi-share,
.bi-three-dots-vertical {
  font-size: 1.1em;
}

/* Button icon styling */
button .bi {
  pointer-events: none;
}

/* Delete icon styling */
.bi-trash3 {
  color: inherit;
}

/* Edit icon styling */
.bi-pencil-square {
  color: inherit;
}

/* Share icon styling */
.bi-share {
  color: inherit;
}

/* Three dots menu styling */
.bi-three-dots-vertical {
  color: inherit;
}

/* Check and X icons for tickets */
.bi-check-lg {
  color: #00ff00;
  font-weight: bold;
  text-shadow: 0 0 2px rgba(0, 255, 0, 0.5);
}

.bi-x-lg {
  color: #dc3545;
  font-weight: bold;
}

/* Close button styling */
.closeButton .bi-x-lg {
  color: #999;
  font-size: 1.2em;
}

.closeButton:hover .bi-x-lg {
  color: #fff;
}

/* Loading spinner animation */
.bi-arrow-repeat {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

/* Action button icons */
.bi-plus-circle {
  color: inherit;
  margin-right: 0.4rem;
}

.bi-check-circle {
  color: inherit;
  margin-right: 0.4rem;
}

.bi-x-circle {
  color: inherit;
  margin-right: 0.4rem;
}`, "",{"version":3,"sources":["webpack://./src/bootstrap-icons.css"],"names":[],"mappings":"AAEA,uCAAuC;AACvC;EACE,cAAc;EACd,cAAc;AAChB;;AAEA,qCAAqC;AACrC;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA,wBAAwB;AACxB;;;;EAIE,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,oBAAoB;AACtB;;AAEA,wBAAwB;AACxB;EACE,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,cAAc;AAChB;;AAEA,4BAA4B;AAC5B;EACE,cAAc;AAChB;;AAEA,kCAAkC;AAClC;EACE,cAAc;EACd,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA,yBAAyB;AACzB;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA,8BAA8B;AAC9B;EACE,kCAAkC;AACpC;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,KAAK,yBAAyB,EAAE;AAClC;;AAEA,wBAAwB;AACxB;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB","sourcesContent":["@import \"bootstrap-icons/font/bootstrap-icons.css\";\n\n/* Custom styling for Bootstrap icons */\n.bi {\n  font-size: 1em;\n  line-height: 1;\n}\n\n/* Icon spacing when used with text */\n.bi + * {\n  margin-left: 0.5rem;\n}\n\n* + .bi {\n  margin-left: 0.5rem;\n}\n\n/* Icon hover effects */\n.bi:hover {\n  transform: scale(1.1);\n  transition: transform 0.2s ease;\n}\n\n/* Specific icon sizes */\n.bi-pencil-square,\n.bi-trash3,\n.bi-share,\n.bi-three-dots-vertical {\n  font-size: 1.1em;\n}\n\n/* Button icon styling */\nbutton .bi {\n  pointer-events: none;\n}\n\n/* Delete icon styling */\n.bi-trash3 {\n  color: inherit;\n}\n\n/* Edit icon styling */\n.bi-pencil-square {\n  color: inherit;\n}\n\n/* Share icon styling */\n.bi-share {\n  color: inherit;\n}\n\n/* Three dots menu styling */\n.bi-three-dots-vertical {\n  color: inherit;\n}\n\n/* Check and X icons for tickets */\n.bi-check-lg {\n  color: #00ff00;\n  font-weight: bold;\n  text-shadow: 0 0 2px rgba(0, 255, 0, 0.5);\n}\n\n.bi-x-lg {\n  color: #dc3545;\n  font-weight: bold;\n}\n\n/* Close button styling */\n.closeButton .bi-x-lg {\n  color: #999;\n  font-size: 1.2em;\n}\n\n.closeButton:hover .bi-x-lg {\n  color: #fff;\n}\n\n/* Loading spinner animation */\n.bi-arrow-repeat {\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n}\n\n/* Action button icons */\n.bi-plus-circle {\n  color: inherit;\n  margin-right: 0.4rem;\n}\n\n.bi-check-circle {\n  color: inherit;\n  margin-right: 0.4rem;\n}\n\n.bi-x-circle {\n  color: inherit;\n  margin-right: 0.4rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
